import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinchichwadpune() {



const cardData =
  {
    keyword: 'Cab Service in Chinchwad Pune',
    heading: 'Sanavi Travels: Cab Service in Chinchwad Pune',
    headingDescription: 'Sanavi Travels offers highly dependable, professionally managed, and comfort-focused Cab Service in Chinchwad Pune, catering to daily commuters, corporate employees, industrial staff, business executives, families, and visitors traveling within and outside Pune. Chinchwad is a major residential, industrial, and corporate hub with constant movement of office employees, factory staff, IT professionals, and business travelers, making reliable cab transportation a daily necessity. Our cab services in Chinchwad Pune are designed to support office commutes, corporate travel, airport transfers, railway station pickups, employee transportation, team outings, and corporate events with efficiency and consistency. We provide a wide range of AC and Non-AC sedans and SUVs, all maintained to high standards of cleanliness, comfort, and safety. Our professional, background-verified drivers are well-versed with Chinchwad routes, peak-hour traffic patterns, industrial zones, IT corridors, and nearby residential areas, ensuring punctual pickups and smooth journeys. Flexible scheduling, multiple pickup points, route optimization, and transparent pricing make our cab service suitable for both daily long-term usage and occasional travel needs. Whether it is regular office travel, corporate guest movement, airport coordination, or group outings, Sanavi Travels ensures stress-free, safe, and cost-effective cab services in Chinchwad Pune, enhancing convenience, productivity, and travel comfort for every passenger.',

    top: 'Cab Travel Services and Use-Cases in Chinchwad Pune',


"topPlaces": [
  {
    "title": "Daily Office Commute in Chinchwad",
    "description": "Cab service in Chinchwad Pune is extensively used for daily office commute by employees working in industrial areas, IT parks, and corporate offices. Reliable cab transport helps employees reach workplaces on time, reduces dependence on crowded public transport, and ensures a safe return journey after long work hours. Organized cab services significantly improve punctuality, comfort, and work-life balance for daily commuters."
  },
  {
    "title": "Industrial and Corporate Zones",
    "description": "Chinchwad is home to several industrial estates and corporate facilities where continuous employee movement is required. Dedicated cab services support smooth transportation of staff, supervisors, managers, and visiting professionals between offices, factories, hotels, and meeting locations. Professional cab arrangements contribute to operational efficiency and disciplined corporate mobility."
  },
  {
    "title": "Airport Transfers from Chinchwad",
    "description": "Frequent airport travel is common for business executives and corporate guests. Cab services from Chinchwad Pune provide timely airport pickups and drops, ensuring stress-free travel with comfortable seating, luggage space, and punctual coordination with flight schedules."
  },
  {
    "title": "Railway Station Pickups and Drops",
    "description": "Cab service in Chinchwad Pune ensures reliable railway station transfers for employees, business visitors, and families. Organized pickups and drops reduce delays, confusion, and reliance on local transport, ensuring smooth connectivity across Pune."
  },
  {
    "title": "Corporate Meetings and Client Visits",
    "description": "Corporate meetings and client visits require punctual, comfortable, and professional transportation. Cab services help executives and guests travel efficiently between offices, hotels, and meeting venues, reflecting a strong corporate image."
  },
  {
    "title": "Employee Transportation Services",
    "description": "Employee transportation in Chinchwad relies heavily on organized cab services for shift-based travel, late-night work hours, and rotational schedules. Safe vehicles, trained drivers, and route familiarity ensure dependable daily commuting."
  },
  {
    "title": "Corporate Events and Conferences",
    "description": "Corporate events, seminars, and conferences often involve guest movement from multiple locations. Dedicated cab services manage coordinated transportation, ensuring timely arrivals and smooth departures."
  },
  {
    "title": "Team Outings and Office Picnics",
    "description": "Team outings and office picnics are common for corporate engagement. Cab services ensure safe, organized, and comfortable travel for groups, allowing teams to enjoy outings without logistical concerns."
  },
  {
    "title": "Residential Area Connectivity",
    "description": "Chinchwad has large residential zones with daily travel needs. Cab services provide reliable connectivity for families, working professionals, students, and senior citizens traveling across Pune."
  },
  {
    "title": "Flexible Multi-Route Travel",
    "description": "Corporate and personal travel often requires flexible routes and multiple pickup points. Dedicated cab services efficiently handle customized travel plans while maintaining punctuality and comfort."
  }
]
,



"services": [
{
"name": "Cab Service in Chinchwad Pune",
"description": "Cab Service in Chinchwad Pune by Sanavi Travels delivers a complete and dependable transportation solution for individuals, families, employees, and corporate clients. This service supports daily office commutes, employee transportation, corporate travel, airport transfers, and local as well as outstation journeys. With well-maintained vehicles, experienced drivers, flexible scheduling, and transparent pricing, it ensures safe, punctual, and comfortable travel. The service reduces travel stress, improves time management, and supports smooth personal and professional mobility across Chinchwad and Pune."
},
{
"name": "AC Cab Hire Chinchwad Pune",
"description": "AC Cab Hire Chinchwad Pune offers a comfortable and refreshing travel experience, especially during peak summer months and long-distance travel. Fully air-conditioned vehicles with clean interiors, smooth suspension, and comfortable seating make daily commutes and corporate travel relaxed and enjoyable."
},
{
"name": "Non AC Cab Chinchwad Pune",
"description": "Non AC Cab Chinchwad Pune provides an economical yet reliable transportation option for budget-conscious travelers. Ideal for short-distance travel and regular usage, it ensures safety, punctuality, and professional driver support without unnecessary costs."
},
{
"name": "Sedan Cab Service Chinchwad Pune",
"description": "Sedan Cab Service Chinchwad Pune is well-suited for individual commuters, executives, and small families. Sedans offer efficient fuel usage, easy maneuverability in traffic, comfortable seating, and a professional appearance for business travel."
},
{
"name": "SUV Cab Service Chinchwad Pune",
"description": "SUV Cab Service Chinchwad Pune supports group travel, family outings, and luggage-heavy journeys. Spacious interiors, higher seating comfort, and stable ride quality make SUVs ideal for long routes and corporate travel."
},
{
"name": "Cab for Office Commute Chinchwad Pune",
"description": "Cab for Office Commute Chinchwad Pune ensures employees reach offices on time with safe and reliable transport. Scheduled pickups, route optimization, and experienced drivers help maintain punctuality and reduce daily travel fatigue."
},
{
"name": "Cab for Corporate Travel Chinchwad Pune",
"description": "Cab for Corporate Travel Chinchwad Pune supports meetings, conferences, client visits, and inter-office movement. Professional service quality and disciplined operations enhance corporate image and travel efficiency."
},
{
"name": "Affordable Cab Service Chinchwad Pune",
"description": "Affordable Cab Service Chinchwad Pune offers cost-effective travel solutions with transparent billing and flexible packages. It helps individuals and companies manage transportation expenses without compromising reliability."
},
{
"name": "Best Cab Service Chinchwad Pune",
"description": "Best Cab Service Chinchwad Pune by Sanavi Travels is trusted for consistency, safety, punctuality, and customer-focused service, making it a preferred choice for regular and corporate travel."
},
{
"name": "Cab with Driver Chinchwad Pune",
"description": "Cab with Driver Chinchwad Pune includes trained, verified chauffeurs familiar with local routes, traffic conditions, and professional etiquette, ensuring smooth and stress-free journeys."
},
{
"name": "Cab for Airport Transfer Chinchwad Pune",
"description": "Cab for Airport Transfer Chinchwad Pune ensures timely pickups and drops aligned with flight schedules, providing comfortable seating, luggage space, and reliable coordination."
},
{
"name": "Cab for Railway Pickup Chinchwad Pune",
"description": "Cab for Railway Pickup Chinchwad Pune offers dependable station transfers, reducing delays and ensuring smooth connectivity for passengers arriving or departing by train."
},
{
"name": "Cab for Employees Chinchwad Pune",
"description": "Cab for Employees Chinchwad Pune focuses on daily commute safety, shift-based scheduling, and dependable transportation, supporting workforce productivity and satisfaction."
},
{
"name": "Cab for Corporate Events Chinchwad Pune",
"description": "Cab for Corporate Events Chinchwad Pune manages transportation for seminars, conferences, product launches, and official gatherings with organized and professional execution."
},
{
"name": "Cab for Team Outing Chinchwad Pune",
"description": "Cab for Team Outing Chinchwad Pune supports office picnics and team-building activities by providing organized, safe, and comfortable group travel arrangements."
}
],
"tableData": [
["Cab Service Chinchwad Pune", "Office Commute Cabs"],
["AC Cabs", "Non AC Cabs"],
["Sedan Cabs", "SUV Cabs"],
["Airport Transfer Cabs", "Railway Pickup Cabs"],
["Employee Transport", "Corporate Event Cabs"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Local Expertise in Chinchwad",
    "WhyChoosedescription": "Sanavi Travels understands Chinchwad travel patterns and provides well-planned cab solutions."
  },
  {
    "WhyChooseheading": "Safe and Reliable Vehicles",
    "WhyChoosedescription": "Well-maintained vehicles and verified drivers ensure passenger safety and comfort."
  },
  {
    "WhyChooseheading": "Punctual and Professional Service",
    "WhyChoosedescription": "On-time pickups and disciplined operations support personal and corporate schedules."
  },
  {
    "WhyChooseheading": "Flexible Travel Options",
    "WhyChoosedescription": "Custom routes, timings, and packages suit varied travel requirements."
  },
  {
    "WhyChooseheading": "Cost-Effective Pricing",
    "WhyChoosedescription": "Transparent pricing helps manage daily and corporate travel budgets."
  },
  {
    "WhyChooseheading": "Comfortable Fleet Options",
    "WhyChoosedescription": "AC and Non-AC sedans and SUVs provide comfort for all travel needs."
  },
  {
    "WhyChooseheading": "Dedicated Customer Support",
    "WhyChoosedescription": "Responsive coordination ensures smooth travel operations."
  },
  {
    "WhyChooseheading": "Trusted Cab Partner",
    "WhyChoosedescription": "Sanavi Travels is trusted for dependable cab services in Chinchwad Pune."
  }
]

}

const faqData = [
  {
    question: 'Do you provide cab service in Chinchwad Pune?',
    answer: 'Yes, Sanavi Travels offers reliable cab services throughout Chinchwad Pune.'
  },
  {
    question: 'Are AC and Non AC cabs available?',
    answer: 'Yes, both AC and Non AC cab options are available.'
  },
  {
    question: 'Can you support daily office commute?',
    answer: 'Yes, we provide scheduled cab services for daily office travel.'
  },
  {
    question: 'Do you offer airport and railway transfers?',
    answer: 'Yes, airport and railway station transfers are available.'
  },
  {
    question: 'Is driver included in cab service?',
    answer: 'Yes, all cab services include a trained and verified driver.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Joshi',
    feedback: 'Very reliable cab service for daily office commute in Chinchwad. Always on time.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Pooja Kulkarni',
    feedback: 'Comfortable and professional cab service for corporate travel. Highly satisfied.',
    rating: 5
  }
];































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Chinchwad Pune - Sanavi Travels",
  "description": "Sanavi Travels offers cab services in Chinchwad Pune for office commute, corporate travel, airport and railway pickups, employee transport, team outings, and corporate events. AC and Non-AC sedans and SUVs are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Cab Service in Chinchwad Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book cab service in Chinchwad Pune with Sanavi Travels. AC & Non-AC sedans and SUVs for office commute, corporate travel, airport, railway, employee transport, team outings, and corporate events with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/261.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinchichwadpune;